var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.06061,
    cy: 8.06061,
    r: 7.81061,
    stroke: "#19B3B5",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90253 9.43678C8.13128 8.39472 9.3502 7.35765 10.5691 6.32556C10.7706 6.15603 10.9721 5.98153 11.1737 5.812C11.4292 5.59761 11.7241 5.58764 11.8962 5.79206C12.0879 6.01643 12.0485 6.36544 11.793 6.58483C10.8738 7.3726 9.95474 8.1554 9.03564 8.94317C8.46058 9.43678 7.88061 9.92541 7.30556 10.419C6.96151 10.7132 6.77965 10.7132 6.4356 10.424C5.73767 9.83067 5.03482 9.23735 4.33198 8.64402C4.26808 8.58917 4.19927 8.52934 4.15012 8.46453C3.9781 8.23517 3.99284 7.96094 4.1747 7.78644C4.39096 7.58201 4.68094 7.56207 4.90703 7.75652C5.36413 8.14044 5.82122 8.52934 6.27341 8.91825C6.48475 9.08278 6.68627 9.2523 6.90253 9.43678Z",
    fill: "#19B3B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLive);
export default __webpack_public_path__ + "static/media/go-live.523fdf2fc7c90f6dc319a71a86168b94.svg";
export { ForwardRef as ReactComponent };